import React, { useState, useCallback } from 'react';
import { graphql } from 'gatsby';

import { Layout, useTranslate } from 'soluble-gatsby-source';

import HeroFormSection from '../components/HeroFormSection';
import BreadcrumbSection from '../components/BreadcrumbSection';
import FormCommunications from '../components/FormCommunications';
import ModalCommunicationsPreventExit from '../components/ModalCommunicationsPreventExit';
import ModalCommunicationsResendEmail from '../components/ModalCommunicationsResendEmail';


export default function CommunicationsPage({ data }) {
    const translate = useTranslate();

    const [ initialLoading, setInitialLoading ] = useState(true);
    const [ preventExitModalProps, setPreventExitModalProps ] = useState(null);
    const [ showResendEmailModal, setShowResendEmailModal ] = useState(false);

    const onLoadToken = useCallback(
        () => {
            setInitialLoading(false);
        },
        [ setInitialLoading ]
    );

    const onPreventExit = useCallback(
        (props) => {
            if (preventExitModalProps) {
                setPreventExitModalProps(null);
            }
            
            setTimeout(() => {
                setPreventExitModalProps(props);
            }, 0);
        },
        [ setPreventExitModalProps, preventExitModalProps ]
    );

    const onResendEmail = useCallback(
        () => {
            if (showResendEmailModal) {
                setShowResendEmailModal(false);
            }

            setTimeout(() => {
                setShowResendEmailModal(true);
            }, 0);
        },
        [ setShowResendEmailModal, showResendEmailModal ]
    );
    
    return (
        <>
            <Layout
                navbarFixed={true}
            >
                <HeroFormSection
                    title={translate['communications-page.hero.title'].text}
                    titleTag="h1"
                    text={translate['communications-page.hero.text'].md}
                    textClassName="body"
                    order={1}
                    isLast={true}
                    colorScheme="secondary"
                    customForm={(
                        <FormCommunications
                            onLoadToken={onLoadToken}
                            onPreventExit={onPreventExit}
                            onResendEmail={onResendEmail}
                        />
                    )}
                    customFormLoading={initialLoading}
                />
                <BreadcrumbSection
                    home={data.home}
                    page={{
                        title: translate['communications-page.hero.title'].text
                    }}
                />
            </Layout>
            {preventExitModalProps ? (
                <ModalCommunicationsPreventExit
                    {...preventExitModalProps}
                />
            ) : null}
            {showResendEmailModal ? (
                <ModalCommunicationsResendEmail />
            ) : null}
        </>
    )
}

export const query = graphql`
    query CommunicationsPage($language: String) {
        home: datoCmsPage(slug: { eq: "" }, locale: { eq: $language }) {
            id
            slug
            title
        }
    }
`